<div class="normalize">
  <router-outlet ></router-outlet>
</div>
